import React from 'react';
const comparisonRows = [{
  without: 'Formulás con intuición',
  with: 'Formulás con criterio'
}, {
  without: 'Improvisás correcciones',
  with: 'Seguís lógica profesional'
}, {
  without: 'Perdés tiempo dudando',
  with: 'Tomás decisiones más rápidas'
}, {
  without: 'Errores más frecuentes',
  with: 'Reducís errores técnicos'
}, {
  without: 'Procesos poco consistentes',
  with: 'Resultados más consistentes'
}, {
  without: 'Más inseguridad con clientas exigentes',
  with: 'Trabajás con más seguridad real'
}];
export function ComparisonTableExtended() {
  return <section className="bg-brand-grayLight py-16 px-5" data-id="element-74">
      <div className="max-w-xl mx-auto" data-id="element-75">
        <h3 className="text-xl md:text-2xl font-black text-slate-900 mb-8 flex items-center gap-3 justify-center" data-id="element-76">
          🧠 TABLA COMPARATIVA
        </h3>

        <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-77">
          <div className="text-xs font-black text-red-500 uppercase tracking-widest flex items-center justify-center gap-2 bg-red-50 py-2 rounded-lg border border-red-100" data-id="element-78">
            ❌ Sin sistema completo
          </div>
          <div className="text-xs font-black text-[#C8A96B] uppercase tracking-widest flex items-center justify-center gap-2 bg-[#C8A96B]/5 py-2 rounded-lg border border-[#C8A96B]/10" data-id="element-79">
            ✅ Con sistema completo
          </div>
        </div>

        <div className="space-y-3" data-id="element-80">
          {comparisonRows.map((row, idx) => <div key={idx} className="grid grid-cols-2 gap-4 border-b border-slate-100 pb-4 last:border-0" data-id="element-81">
              <p className="text-sm text-slate-400 font-medium leading-relaxed italic" data-id="element-82">
                {row.without}
              </p>
              <p className="text-sm text-slate-700 font-bold leading-relaxed" data-id="element-83">
                {row.with}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}